import axios from 'axios';
import { getPortalSupportedLocalization } from '@next/shared';
import { useQuery } from '@tanstack/react-query';
import { useLocalizationContext } from 'shared/lib/localization';
import { AnnexLegalDocumentResponseModel } from '@next/backend-client';

export const useAnnexDpa = () => {
    const { language } = useLocalizationContext();

    const { data, isFetching, isError } = useQuery({
        queryKey: ['annex-dpa', language],
        queryFn: async (): Promise<AnnexLegalDocumentResponseModel> => {
            const response = await axios.get(`${process.env.PUBLIC_URL}/annex-dpa`, {
                params: { locale: getPortalSupportedLocalization(language) },
            });

            return response.data;
        },
        enabled: !!language,
    });

    return { document: data?.Text, isFetching, isError };
};
